// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    notifications: [],
    isLoading: false,
    socket:"",
    walletUpdater:0,
    orderUpdater:0,
    online:false
  },
  reducers: {
    handleSetNotifications: (state, action) => {
      state.notifications = action.payload
    },
    handleSocket: (state, action) => {
      state.socket = action.payload
    },

    handleWalletUpdater: (state, action) => {
      state.walletUpdater = state.walletUpdater + 1
    },

    handleOrderUpdater: (state, action) => {
      state.orderUpdater = state.orderUpdater + 1
    },
    handleOnlineUser: (state, action) => {
      state.online = action.payload
    }
  }
})

export const { handleSetNotifications, handleSocket, handleWalletUpdater, handleOrderUpdater, handleOnlineUser} = notificationSlice.actions

export default notificationSlice.reducer
